/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicUserLicenseInfo
 */
export interface PublicUserLicenseInfo {
    /**
     * 
     * @type {string}
     * @memberof PublicUserLicenseInfo
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUserLicenseInfo
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUserLicenseInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUserLicenseInfo
     */
    licenseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUserLicenseInfo
     */
    state: string;
}

/**
 * Check if a given object implements the PublicUserLicenseInfo interface.
 */
export function instanceOfPublicUserLicenseInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "licenseNumber" in value;
    isInstance = isInstance && "state" in value;

    return isInstance;
}

export function PublicUserLicenseInfoFromJSON(json: any): PublicUserLicenseInfo {
    return PublicUserLicenseInfoFromJSONTyped(json, false);
}

export function PublicUserLicenseInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicUserLicenseInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'licenseNumber': json['license_number'],
        'state': json['state'],
    };
}

export function PublicUserLicenseInfoToJSON(value?: PublicUserLicenseInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'license_number': value.licenseNumber,
        'state': value.state,
    };
}

